import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import CatalogCard from "@/Components/Site/CatalogCard";
import {isDesktop, isMobile, scrollToElement} from "@/Helpers/Function";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/one.scss';

class One extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSvg: false,
            videoPlayPauseFlag: true,
            videoNorthernLightsVolumeSvg: true,
            // Сколько показывать карточек при загрузке
            cardOneListCount: 10,
            cardTwoListCount: 10,
            cardThreeListCount: 10,
            cardFourListCount: 10,
            // Сколько прибавлять карточек (показать еще)
            cardOneListCountAdd: 10,
            cardTwoListCountAdd: 10,
            cardThreeListCountAdd: 10,
            cardFourListCountAdd: 10,
            // Количество активных карточек при старте
            cardOneActive: [],
            cardTwoActive: [],
            cardThreeActive: [],
            cardFourActive: [],
            // Флаги
            setOne: false,
            setTwo: false,
            setThree: false,
            setFour: false,
        };
        this.videoRef = React.createRef();
        this.setOneRef = React.createRef();
        this.setTwoRef = React.createRef();
        this.setThreeRef = React.createRef();
        this.setFourRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRef.current !== null) {
            const video = this.videoRef.current;
            video.onended = (e) => {
                video.muted = true;
                this.setState({
                    videoSvg: true,
                    videoNorthernLightsVolumeSvg: true
                })
            };
        }
    }

    videoTimer = () => setTimeout(() => {
        this.setState({videoPlayPauseFlag: false})
    }, 3000);

    /**
     * Управление звуком
     */
    mediaChangeVolume = () => {
        try {
            const video = this.videoRef.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoNorthernLightsVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({videoNorthernLightsVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPause = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerId);
                if (!this.state.videoPlayPauseFlag) {
                    this.setState({videoPlayPauseFlag: true})
                }
                this.videoTimerId = this.videoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChange = () => {
        try {
            const video = this.videoRef.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvg: false})
            } else {
                video.pause();
                this.setState({videoSvg: true})
            }
            video.onended = (e) => {
                this.setState({videoSvg: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    setOpen = (set, ref) => {
        if (!this.state[set]) {
            this.setState({[set]: true});
        }
        const options = {block: "start", inline: "center", behavior: "smooth"};
        setTimeout(() => {
            scrollToElement(this[ref].current, options);
        }, 10)
    }

    // Добавляем карточки при клике на (показать еще)
    showMore = (set, setAdd) => {
        this.setState({
            [set]: this.state[set] + this.state[setAdd],
        });
    }

    // Показать еще текст кнопки
    showMoreMessage = (count, setAdd) => {
        if (this.state[setAdd] < count) {
            return `Показать еще ${this.state[setAdd]} из ${count}`;
        } else {
            return `Показать еще ${count}`;
        }
    };

    render() {
        const {collectionDetailedData = {}, uploadUrl = '', registerView} = this.props;

        const {
            setOne,
            setTwo,
            setThree,
            setFour,
            videoSvg,
            videoPlayPauseFlag,
            videoNorthernLightsVolumeSvg
        } = this.state;

        let offset = 0;

        // Получаем массив с нужным количеством карточек при старте
        this.state.cardOneActive = collectionDetailedData.platinaOne.slice(0, this.state.cardOneListCount);
        const countOne = collectionDetailedData.platinaOne.length - this.state.cardOneActive.length;
        const dataOne = this.state.cardOneActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaOne.length;
        this.state.cardTwoActive = collectionDetailedData.platinaTwo.slice(0, this.state.cardTwoListCount);
        const countTwo = collectionDetailedData.platinaTwo.length - this.state.cardTwoActive.length;
        const dataTwo = this.state.cardTwoActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaTwo.length;
        this.state.cardThreeActive = collectionDetailedData.platinaThree.slice(0, this.state.cardThreeListCount);
        const countThree = collectionDetailedData.platinaThree.length - this.state.cardThreeActive.length;
        const dataThree = this.state.cardThreeActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaThree.length;
        this.state.cardFourActive = collectionDetailedData.platinaFour.slice(0, this.state.cardFourListCount);
        const countFour = collectionDetailedData.platinaFour.length - this.state.cardFourActive.length;
        const dataFour = this.state.cardFourActive.map((product, i) => {
            return <CatalogCard
                key={product.id}
                el={product}
                {...this.props}
                index={offset + i + 1}
                registerView={registerView}
            />
        });
        offset += collectionDetailedData.platinaFour.length;

        return <section className={`section section__one`}>
            <div className={`collections-lp`}>
                <div className={`container`}>
                    <div className={`svgOneTop`}>
                        <Svg id={`platina-one`} className={`svg__platina-one`} />
                    </div>
                    <div className={`one-wrapper`}>
                        <div className={`one-wrapper__video-main`}>
                            <video ref={this.videoRef}
                                   autoPlay
                                   muted={`muted`}
                                   preload={`none`}
                                   width={`100%`}
                                   poster={isMobile() ? `/storage/img/collections/one/video-poster-mobile.jpg` : '/storage/img/collections/one/video-poster.jpg'}
                            >
                                {isMobile() ?
                                    <>
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_1x1_768_2.5mbps.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_1x1_768_2.5mbps.webm`}
                                            type={`video/webm`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_1x1_768_2.5mbps.ogg`}
                                            type={`video/ogg`} />
                                    </>
                                    :
                                    <>
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_16x9_1330_2.5mbps.mp4`}
                                            type={`video/mp4`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_16x9_1330_2.5mbps.webm`}
                                            type={`video/webm`} />
                                        <source
                                            src={`${uploadUrl}/media/video/collections/one/ONE_16x9_1330_2.5mbps.ogg`}
                                            type={`video/ogg`} />
                                    </>
                                }
                            </video>
                            <div className={`video-control`}
                                 onClick={() => this.mediaChangePlayPause()}>
                                {videoSvg ?
                                    <>
                                        <div className={`gg-play-button`}
                                             onClick={() => this.mediaChange()}></div>
                                    </>
                                    :
                                    <>
                                        {videoPlayPauseFlag && (
                                            <div className={`gg-pause-button`}
                                                 onClick={() => this.mediaChange()}></div>
                                        )}
                                    </>
                                }
                                <div className={`volume`}
                                     onClick={() => this.mediaChangeVolume()}>
                                    {videoNorthernLightsVolumeSvg ?
                                        <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                                        :
                                        <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                                    }
                                </div>
                            </div>
                        </div>
                        <h1 className={`h1 h1__one`}>
                            PLATINA ONE&nbsp;&mdash; коллекция золотых украшений для уверенных в&nbsp;себе
                            женщин!
                        </h1>
                        <div className={`one-wrapper__description one-wrapper__description_one`}>
                            <p>
                                Какой вы&nbsp;хотите быть в&nbsp;каждом мгновении жизни? Стильной?
                                Решительной? Динамичной? Чувственной? С&nbsp;украшениями коллекции вы&nbsp;сами
                                сможете создавать свою реальность, свой желанный образ! Это украшения для тех,
                                кто ценит значимость каждого мгновения! Каждое украшение
                                коллекции&nbsp;&mdash; это проявление вашей безупречности в&nbsp;любой ситуации!
                            </p>
                        </div>
                        <div className={`one-wrapper__description one-wrapper__description_two`}>
                            <p>
                                Коллекция PLATINA ONE&nbsp;&mdash; это четыре ярких сета, отразивших идею
                                неповторимости жизни. Её&nbsp;лёгкость и&nbsp;чувственность. Стремительность
                                и&nbsp;динамику. Удачу и&nbsp;мгновения счастья. Мудрость и&nbsp;безграничные
                                возможности.
                            </p>
                        </div>
                        <div className={`one-wrapper__set one-wrapper__set_one`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/babochki-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/babochki.webp`}
                                />
                                <source srcSet={`/storage/img/collections/one/babochki-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/one/babochki.jpg`}
                                     alt={`Сет бабочки - мгновения красоты`}
                                     title={`Сет бабочки - мгновения красоты`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`one-wrapper__set-content one-wrapper__set-content_odd one-wrapper__set-content_one`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>Бабочки</p>
                                <p className={`subtitle`}>Мгновения красоты</p>
                                <p className={`text`}>
                                    Анималистика и&nbsp;геометрия&nbsp;&mdash; эффектный тандем модных стилей.
                                    Трендовое сочетание оттенков металла и&nbsp;выразительность объёмных
                                </p>
                                {collectionDetailedData.platinaOne.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-one`}
                                         onClick={() => this.setOpen('setOne', 'setOneRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setOne && (
                            <>
                                <div className={`cardAll cardAll__platinaOne`}
                                     ref={this.setOneRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataOne}
                                    </div>
                                </div>
                                {countOne !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardOneListCount', 'cardOneListCountAdd')}>
                                            {this.showMoreMessage(countOne, 'cardOneListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`one-wrapper__set one-wrapper__set_two`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/strekozy-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/strekozy.webp`}
                                />
                                <source srcSet={`/storage/img/collections/one/strekozy-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/one/strekozy.jpg`}
                                     alt={`Сет стрекозы - ценность настоящего`}
                                     title={`Сет стрекозы - ценность настоящего`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`one-wrapper__set-content one-wrapper__set-content_even one-wrapper__set-content_two`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>Стрекозы</p>
                                <p className={`subtitle`}>Ценность настоящего</p>
                                <p className={`text`}>
                                    Стильный дуэт совершенства геометрических линий и&nbsp;грации образа.
                                    Игра света на&nbsp;фактурных узорах
                                </p>
                                {collectionDetailedData.platinaTwo.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-one`}
                                         onClick={() => this.setOpen('setTwo', 'setTwoRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setTwo && (
                            <>
                                <div className={`cardAll cardAll__platinaOne`}
                                     ref={this.setTwoRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataTwo}
                                    </div>
                                </div>
                                {countTwo !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardTwoListCount', 'cardTwoListCountAdd')}>
                                            {this.showMoreMessage(countTwo, 'cardTwoListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`one-wrapper__set one-wrapper__set_three`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/klever-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/klever.webp`}
                                />
                                <source srcSet={`/storage/img/collections/one/klever-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/one/klever.jpg`}
                                     alt={`Сет клевер - незабываемые моменты`}
                                     title={`Сет клевер - незабываемые моменты`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`one-wrapper__set-content one-wrapper__set-content_odd one-wrapper__set-content_three`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>Клевер</p>
                                <p className={`subtitle`}>Незабываемые моменты</p>
                                <p className={`text`}>
                                    Флористика и&nbsp;лаконичная геометрия&nbsp;&mdash; трендовое сочетание
                                    стилей. Максимальный акцент на&nbsp;плавных линиях и&nbsp;простоте силуэтов
                                </p>
                                {collectionDetailedData.platinaThree.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-one`}
                                         onClick={() => this.setOpen('setThree', 'setThreeRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setThree && (
                            <>
                                <div className={`cardAll cardAll__platinaOne`}
                                     ref={this.setThreeRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataThree}
                                    </div>
                                </div>
                                {countThree !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardThreeListCount', 'cardThreeListCountAdd')}>
                                            {this.showMoreMessage(countThree, 'cardThreeListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                        <div className={`one-wrapper__set one-wrapper__set_four`}>
                            <picture>
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/zmei-mobile.webp`}
                                        media="(max-width: 767px)"
                                />
                                <source type="image/webp"
                                        srcSet={`/storage/img/collections/one/zmei.webp`}
                                />
                                <source srcSet={`/storage/img/collections/one/zmei-mobile.jpg`}
                                        media="(max-width: 767px)"
                                />
                                <img src={`/storage/img/collections/one/zmei.jpg`}
                                     alt={`Сет змеи - безграничность возможностей`}
                                     title={`Сет змеи - безграничность возможностей`}
                                     loading="lazy"
                                     width={isMobile() ? "767" : "1500"}
                                     height={isMobile() ? "790" : "624"}
                                />
                            </picture>
                            <div
                                className={`one-wrapper__set-content one-wrapper__set-content_even one-wrapper__set-content_four`}>
                                <p className={`set`}>Сет</p>
                                <p className={`title`}>Змеи</p>
                                <p className={`subtitle`}>Безграничность возможностей</p>
                                <p className={`text`}>
                                    Совершенство форм и&nbsp;силуэтов. Эффектное единение значимых образов.
                                </p>
                                {collectionDetailedData.platinaFour.length !== 0 && (
                                    <div className={`btn btn__default btn__platina-one`}
                                         onClick={() => this.setOpen('setFour', 'setFourRef')}>
                                        Украшения сета
                                        <Svg id={`arrows-right`} className={`svg__arrow-right-one`} />
                                    </div>
                                )}
                            </div>
                        </div>
                        {setFour && (
                            <>
                                <div className={`cardAll cardAll__platinaOne`}
                                     ref={this.setFourRef}>
                                    <div className={`cardAll__catalog`}>
                                        {dataFour}
                                    </div>
                                </div>
                                {countFour !== 0 && (
                                    <div className={`buttons buttons__showMore`}>
                                        <div className={`btn btn__showMore`}
                                             onClick={() => this.showMore('cardFourListCount', 'cardFourListCountAdd')}>
                                            {this.showMoreMessage(countFour, 'cardFourListCountAdd')}
                                        </div>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    }
}

export default withViewItemBatcher(useWithStore(One));
